import { ReactElement, useState } from 'react';

// Local Typings
interface ChildrenProps {
  isDebouncing: boolean;
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
}
interface Props {
  children: (props: ChildrenProps) => ReactElement;
  debounceDuration?: number;
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onDebounce: (value: string) => void;
}

// Component Definition
const Debouncer: React.FC<Props> = ({
  children,
  debounceDuration = 300,
  onChange,
  onDebounce,
}) => {
  const [debounce, setDebounce] = useState<null | number>(null);

  function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
    const { value } = evt.target;
    if (onChange) {
      onChange(evt);
    }
    if (debounce) {
      clearTimeout(debounce);
    }
    const timeout = window.setTimeout(() => {
      onDebounce(value);
      setDebounce(null);
    },
    debounceDuration);
    setDebounce(timeout);
  }

  return children({
    isDebouncing: !!debounce,
    onChange: handleChange,
  });
};

export default Debouncer;
